import request from '@/utils/request'

export const getBillList = (data) => {
  return request({
    url: '/manage/bill/get-check-list',
    method: 'post',
    data
  })
}
export const getBillListN = (data) => {
  return request({
    url: '/manage/bills/list',
    method: 'post',
    data
  })
}
export const getBillInfo= (data) => {
  return request({
    url: '/manage/bills/batch-info',
    method: 'post',
    data
  })
}

export const getBillDetail = (data) => {
  return request({
    url: '/manage/bill/check-batch-info',
    method: 'post',
    data
  })
}

export const getBillDetailN = (data) => {
  return request({
    url: '/manage/bills/get-history',
    method: 'post',
    data
  })
}

export const getUsers = (data) => {
  return request({
    url: '/manage/bill/get-users',
    method: 'post',
    data
  })
}

export const updateStatus = (data) => {
  return request({
    url: '/manage/bill/update-status',
    method: 'post',
    data
  })
}

export const updateStatusN = (data) => {
  return request({
    url: 'manage/bills/update-status',
    method: 'post',
    data
  })
}

export const sendUsers = (data) => {
  return request({
    url: '/manage/bill/send-users',
    method: 'post',
    data
  })
}
